export default {"src":"/_next/static/media/chevron-left.ce94f540.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};